import { ONLINE_TIMEOUT_MS } from '../../constants';

const presenceTime = (value: any) =>
  value?.toMillis?.() || value?.seconds * 1000 || new Date(value || 0).getTime();

export const isUserOnline = (user: any, now = Date.now()) =>
  user?.isOnline === true &&
  (!user.lastActiveAt || now - presenceTime(user.lastActiveAt) < ONLINE_TIMEOUT_MS);
